import { useEffect, useState } from "react";

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

import HorarioOpcoes from "../HorarioOpcoes";

const modoDe = (campanha) => (campanha?.horario_modo === "funcionamento" ? "funcionamento" : "dia_todo");

/**
 * Trocar quando o anúncio aparece numa campanha que já está rodando: só com a
 * loja aberta ou o dia todo. Salvar "só com a loja aberta" de novo reaplica o
 * horário de funcionamento de agora (a campanha não acompanha sozinha).
 */
export default function DialogoHorario({ campanha, horario, aoFechar, aoSalvar }) {
  const atual = modoDe(campanha);
  const [modo, setModo] = useState(atual);
  const [salvando, setSalvando] = useState(false);
  useEffect(() => { if (campanha) setModo(modoDe(campanha)); }, [campanha]);
  if (!campanha) return null;

  const mudou = modo !== atual;
  const reaplicar = !mudou && modo === "funcionamento";
  const salvar = async () => {
    setSalvando(true);
    const ok = await aoSalvar(modo);
    setSalvando(false);
    if (ok) aoFechar();
  };

  return (
    <Dialog open onOpenChange={(aberto) => !aberto && aoFechar()}>
      <DialogContent data-e2e="dialogo-horario">
        <DialogHeader>
          <DialogTitle>Quando o anúncio aparece</DialogTitle>
          <DialogDescription>
            Hoje “{campanha.titulo}” aparece {atual === "funcionamento" ? "só com a loja aberta" : "o dia todo, também com a loja fechada"}. Anunciar com a loja fechada gasta dinheiro com quem não consegue pedir.
          </DialogDescription>
        </DialogHeader>
        <div>
          <HorarioOpcoes modo={modo} horario={horario} aoEscolher={setModo} prefixo="dialogo" />
          {modo === "funcionamento" && horario?.tem && (
            <p className="text-[11px] text-muted-foreground mt-2">
              A Meta trabalha em horas cheias: o início arredonda para baixo e o fim para cima. Se o horário da loja mudar, salve aqui de novo para o anúncio acompanhar.
            </p>
          )}
        </div>
        <DialogFooter>
          <button type="button" onClick={aoFechar} className="h-10 px-4 rounded-lg border text-sm font-medium hover:bg-muted">Cancelar</button>
          <button type="button" onClick={salvar} disabled={salvando || (!mudou && !reaplicar)} data-e2e="dialogo-horario-salvar"
            className="h-10 px-5 rounded-lg bg-primary text-primary-foreground text-sm font-semibold disabled:opacity-50">
            {salvando ? "Salvando…" : reaplicar ? "Reaplicar o horário da loja" : "Salvar horário"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
